import { forwardRef, PropsWithChildren } from 'react'
import { Sprinkles } from 'ui/theme/sprinkles.css'
import { FlexBox } from '../FlexBox'
import { reel } from './Reel.css'

interface Props {
	space?: Sprinkles['gap']
}

export const Reel = forwardRef<HTMLElement, PropsWithChildren<Props>>(({ children, space = 'md' }, ref) => {
	return (
		<FlexBox gap={space} ref={ref} className={reel}>
			{children}
		</FlexBox>
	)
})
